import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { AuthenticationPageLayout } from '@/app/shell/AuthenticationPageLayout';
import { buildDiagnosticReport } from '@/lib/diagnostics';

export function RootErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();
  const [copied, setCopied] = useState(false);

  console.error('[RootErrorBoundary] Unhandled route error', error);

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);

  const copyReport = async () => {
    await navigator.clipboard.writeText(buildDiagnosticReport({ error }));
    setCopied(true);
  };

  return (
    <AuthenticationPageLayout>
      <div>
        <p role="alert">
          {t('Error_UnexpectedError', {
            defaultValue: 'Something went wrong. Please try reloading the page.',
          })}
        </p>
        {import.meta.env.DEV && detail !== '' && <p className="text-muted small">{detail}</p>}
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            {t('Button_TryAgain', { defaultValue: 'Try again' })}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => void copyReport()}>
            {copied ? t('Tooltip_CopiedToClipboard') : t('Blazor_UnhandledError_Copy')}
          </button>
        </div>
      </div>
    </AuthenticationPageLayout>
  );
}
